export default {
  BASE_URL: 'mm/priceIndex/',
  api: [
    {
      name: 'downloadTemplate',
      method: 'GET',
      desc: '下载导入模板',
      path: 'template/priceIndex'
    },
    {
      name: 'cityList',
      method: 'GET',
      desc: '获取地区',
      path: 'city/list'
    },
    {
      name: 'priceType',
      method: 'GET',
      desc: '获取价格类型列表',
      path: 'priceType/list'
    },
    {
      name: 'popData',
      method: 'POST',
      desc: '导入模板数据',
      path: 'import'
    }, {
      name: 'priceIndexList',
      method: 'POST',
      desc: '获取价格指数列表',
      path: 'list'
    }, {
      name: 'editPrice',
      method: 'POST',
      desc: '批量修改价格',
      path: 'editPrice'
    }, {
      name: 'deletePrice',
      method: 'POST',
      desc: '批量删除',
      path: 'delete'
    }
  ]

}



// WEBPACK FOOTER //
// ./src/api/apis/cms/priceFixed.js